import type { SVGProps } from 'react'
const SvgSyArrowUpCircleSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m6.5 11.4 1.2 1.2 3.4-3.3v8.6h1.8V9.3l3.4 3.3 1.2-1.2L12 5.8z" />
		<path d="M12 .3C5.6.3.3 5.6.3 12S5.5 23.7 12 23.7c6.4 0 11.7-5.2 11.7-11.7C23.7 5.6 18.5.3 12 .3M19 19c-1.8 1.8-4.3 2.9-7 2.9S6.8 20.8 5 19s-2.9-4.3-2.9-7S3.2 6.8 5 5s4.3-2.9 7-2.9 5.2 1.1 7 2.9 2.9 4.3 2.9 7-1.1 5.2-2.9 7" />
	</svg>
)
export default SvgSyArrowUpCircleSystem
